/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Final_HeadingInputs */

const en_funnel_sq_final_heading = /** @type {(inputs: Funnel_Sq_Final_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to clear your reading list?`)
};

const es_funnel_sq_final_heading = /** @type {(inputs: Funnel_Sq_Final_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para despejar tu lista de lectura?`)
};

/**
* | output |
* | --- |
* | "Ready to clear your reading list?" |
*
* @param {Funnel_Sq_Final_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_final_heading = /** @type {((inputs?: Funnel_Sq_Final_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Final_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_final_heading(inputs)
	return en_funnel_sq_final_heading(inputs)
});